import PropTypes from 'prop-types'
import { useCallback, useContext } from 'react'
import { UsuarioContext } from '../context/usuarioContext'
import { useDropzoneUpload } from '../hooks/useDropzoneUpload'
import ImagenPerfil from '../imagen/ImagenPerfil'
import * as imagenesPerfilService from '../servicios/imagenesPerfilService'
import styles from './Perfil.module.css'

const Upload = ({ idUsuario, accept, idTipo }) => {
  const { setImagenModif } = useContext(UsuarioContext)

  const buildFormData = useCallback(
    (archivo) => {
      const imagen = new FormData()
      imagen.append('nombre', archivo.name)
      imagen.append('idUsuario', idUsuario)
      imagen.append('archivo', archivo)
      imagen.append('idTipo', idTipo)
      return imagen
    },
    [idUsuario, idTipo]
  )

  const { getRootProps, getInputProps } = useDropzoneUpload({
    accept,
    buildFormData,
    uploadFn: imagenesPerfilService.subirArchivo,
    onSuccess: (archivo) => setImagenModif(archivo.lastModified)
  })

  return (
    <div className={styles.uploadZone} {...getRootProps()}>
      <input {...getInputProps()} />
      <div className={styles.uploadPreview}>
        <ImagenPerfil idUsuario={idUsuario} clase="subida-img"></ImagenPerfil>
      </div>
      <p className={styles.uploadHint}>
        Hacé click para cambiar tu foto de perfil. Soltá tu fotografía acá ó arrastrala desde tu
        computadora.
      </p>
    </div>
  )
}

Upload.propTypes = {
  idUsuario: PropTypes.number.isRequired,
  accept: PropTypes.object.isRequired,
  idTipo: PropTypes.number.isRequired
}

export default Upload
